import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <footer className="bg-[#f8f9fa] border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          <div className="md:col-span-2">
            <img
              src="https://public.readdy.ai/ai/img_res/f6f2763d-db5f-4bb2-a284-c0c30ee4ca43.png"
              alt="Service Immobil Sicily"
              className="h-12 w-auto object-contain mb-4"
            />
            <p className="text-sm text-gray-600 leading-relaxed max-w-md">
              {t('footer_desc')}
            </p>
          </div>

          <div>
            <h4 className="text-sm font-bold text-gray-900 mb-4">{t('footer_services')}</h4>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-sm text-gray-600 hover:text-[#1e3a8a] transition-colors cursor-pointer"
                >
                  {t('service1_title')}
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-sm text-gray-600 hover:text-[#1e3a8a] transition-colors cursor-pointer"
                >
                  {t('service2_title')}
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-sm text-gray-600 hover:text-[#1e3a8a] transition-colors cursor-pointer"
                >
                  {t('service3_title')}
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-sm text-gray-600 hover:text-[#1e3a8a] transition-colors cursor-pointer"
                >
                  {t('service4_title')}
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-gray-900 mb-4">{t('footer_company')}</h4>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => scrollToSection('about')}
                  className="text-sm text-gray-600 hover:text-[#1e3a8a] transition-colors cursor-pointer"
                >
                  {t('footer_about')}
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('case-studies')}
                  className="text-sm text-gray-600 hover:text-[#1e3a8a] transition-colors cursor-pointer"
                >
                  {t('nav_references')}
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contact')}
                  className="text-sm text-gray-600 hover:text-[#1e3a8a] transition-colors cursor-pointer"
                >
                  {t('nav_contact')}
                </button>
              </li>
            </ul>

            <div className="mt-6">
              <h4 className="text-sm font-bold text-gray-900 mb-3">{t('footer_contact')}</h4>
              <a
                href="mailto:info@immobilitalia.com"
                className="text-sm text-gray-600 hover:text-[#1e3a8a] transition-colors block cursor-pointer"
              >
                info@immobilitalia.com
              </a>
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-gray-200">
          <p className="text-sm text-gray-600 text-center">
            © {new Date().getFullYear()} Service Immobil Sicily. {t('footer_copyright')}
          </p>
        </div>
      </div>
    </footer>
  );
}
